import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-product-display-zone',
  templateUrl: './delete-product-display-zone.component.html',
  styleUrls: ['./delete-product-display-zone.component.css']
})
export class DeleteProductDisplayZoneComponent implements OnInit {

  productDisplayZoneList: any= []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleProductDisplayZoneData: any= []
  deleteProductDisplayZoneId:any = ""

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllProductDisplayZone();
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllProductDisplayZone();
  }

  getAllProductDisplayZone(){
    this.generic_service.getAllProductDisplayZone().subscribe(
      (response:any)=>{
        console.log(response);
        this.productDisplayZoneList = response.response
      }
    )
  }

  getProductDisplayZoneById(productDisplayZoneById:any){
    this.generic_service.getProductDisplayZoneById(productDisplayZoneById).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleProductDisplayZoneData.push(res.response)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  selectProductDisplayZone(id:any){
    this.deleteProductDisplayZoneId = id
  }

  deleteProductDisplayZoneById(){
    this.generic_service.deleteProductDisplayZone(this.deleteProductDisplayZoneId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllProductDisplayZone()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

}


